export const AUTH_EXPIRED = 'tonmm:auth-expired';
export const SESSION_EXPIRED_MESSAGE = 'Сессия истекла или была обновлена. Войдите снова.';

export function expireSession(requestToken) {
  // A late response from an old session must not erase a newer login.
  if (!requestToken || localStorage.getItem('auth_token') !== requestToken) return false;
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user_data');
  sessionStorage.setItem('auth_message', SESSION_EXPIRED_MESSAGE);
  window.dispatchEvent(new Event(AUTH_EXPIRED));
  return true;
}

export function handleApiAuthError(error) {
  if (error.response?.status !== 401) return false;
  const config = error.config || {};
  let url;
  try { url = new URL(config.url || '', new URL(config.baseURL || '/', window.location.href)); }
  catch { return false; }
  if (!url.pathname.startsWith('/api/') || url.pathname === '/api/auth/login') return false;
  const header = config.headers?.get?.('Authorization') || config.headers?.Authorization || config.headers?.authorization || '';
  return expireSession(header.startsWith('Bearer ') ? header.slice(7) : '');
}
